// Here is the ticket, where we pulled the offering ID's
// https://hello.atlassian.net/browse/BXPSU-421

import { ProductKey as ProductKeys } from '../constants';

enum PricingType {
  FREE = 'FREE',
  PAID = 'PAID',
  LIMITED_FREE = 'LIMITED_FREE'
}

const OFFERING_IDS = {
  dev: {
    [ProductKeys.JIRA_SOFTWARE]: {
      free: {
        offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.CONFLUENCE]: {
      free: {
        offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_SERVICE_MANAGEMENT]: {
      free: {
        offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'agent'
      },
      standard: {
        offeringId: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'agent'
      },
      premium: {
        offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'agent'
      },
      halp: {
        offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`, // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
        pricingPlanId: '7701f274-6c84-45cd-bdb0-493a67355e61', // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
        pricingType: PricingType.PAID, // pricing type for CCP
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        edition: 'standard',
        chargeElement: 'agent'
      }
    },
    [ProductKeys.JIRA_WORK_MANAGEMENT]: {
      free: {
        offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_PRODUCT_DISCOVERY]: {
      free: {
        offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.COMPASS]: {
      beta: {
        offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
        productKey: ProductKeys.COMPASS,
        edition: 'beta',
        chargeElement: 'user'
      },
      free: {
        offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.ATLAS]: {
      free: {
        offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.OPSGENIE]: {
      free: {
        offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
        productKey: ProductKeys.OPSGENIE,
        pricingType: PricingType.FREE,
        edition: 'essentials',
        chargeElement: 'user'
      }
    },
    [ProductKeys.FABRIC]: {
      free: {
        offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
        productKey: ProductKeys.FABRIC,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.STATUSPAGE]: {
      free: {
        offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
        productKey: ProductKeys.STATUSPAGE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.BITBUCKET]: {
      free: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    }
  },
  staging: {
    [ProductKeys.JIRA_SOFTWARE]: {
      free: {
        offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      standard: {
        offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      premium: {
        offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      }
    },
    [ProductKeys.CONFLUENCE]: {
      free: {
        offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_SERVICE_MANAGEMENT]: {
      free: {
        offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'agent',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      standard: {
        offeringId: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'agent',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      premium: {
        offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'agent',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      halp: {
        offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`, // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
        pricingPlanId: '7701f274-6c84-45cd-bdb0-493a67355e61', // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
        pricingType: PricingType.PAID, // pricing type for CCP
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        edition: 'standard',
        chargeElement: 'agent'
      }
    },
    [ProductKeys.JIRA_WORK_MANAGEMENT]: {
      free: {
        offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      standard: {
        offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user',
        jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
      },
      premium: {
        offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_PRODUCT_DISCOVERY]: {
      free: {
        offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.COMPASS]: {
      beta: {
        offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
        productKey: ProductKeys.COMPASS,
        edition: 'beta',
        chargeElement: 'user'
      },
      free: {
        offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.ATLAS]: {
      free: {
        offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.OPSGENIE]: {
      free: {
        offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
        productKey: ProductKeys.OPSGENIE,
        pricingType: PricingType.FREE,
        edition: 'essentials',
        chargeElement: 'user'
      }
    },
    [ProductKeys.FABRIC]: {
      free: {
        offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
        productKey: ProductKeys.FABRIC,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.STATUSPAGE]: {
      free: {
        offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
        productKey: ProductKeys.STATUSPAGE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.BITBUCKET]: {
      free: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    }
  },
  production: {
    [ProductKeys.JIRA_SOFTWARE]: {
      free: {
        offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
        productKey: ProductKeys.JIRA_SOFTWARE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.CONFLUENCE]: {
      free: {
        offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
        productKey: ProductKeys.CONFLUENCE,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_SERVICE_MANAGEMENT]: {
      free: {
        offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'agent'
      },
      standard: {
        offeringId: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'agent'
      },
      premium: {
        offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'agent'
      },
      halp: {
        offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
        pricingPlanId: '200b2088-934b-4669-b7c5-7ae6961c9368', // https://workbench.prod.atl-paas.net/products/jira-servicedesk.ondemand/plans/200b2088-934b-4669-b7c5-7ae6961c9368
        pricingType: PricingType.PAID, // pricing type for CCP
        productKey: ProductKeys.JIRA_SERVICE_MANAGEMENT,
        edition: 'standard',
        chargeElement: 'agent'
      }
    },
    [ProductKeys.JIRA_WORK_MANAGEMENT]: {
      free: {
        offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
        productKey: ProductKeys.JIRA_WORK_MANAGEMENT,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.JIRA_PRODUCT_DISCOVERY]: {
      free: {
        offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.COMPASS]: {
      beta: {
        offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
        productKey: 'compass',
        edition: 'beta',
        chargeElement: 'user'
      },
      free: {
        offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
        productKey: ProductKeys.COMPASS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      }
    },
    [ProductKeys.ATLAS]: {
      free: {
        offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
        productKey: ProductKeys.ATLAS,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    },
    [ProductKeys.OPSGENIE]: {
      free: {
        offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
        productKey: ProductKeys.OPSGENIE,
        pricingType: PricingType.FREE,
        edition: 'essentials',
        chargeElement: 'user'
      }
    },
    [ProductKeys.FABRIC]: {
      free: {
        offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
        productKey: ProductKeys.FABRIC,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.STATUSPAGE]: {
      free: {
        offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
        productKey: ProductKeys.STATUSPAGE,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      }
    },
    [ProductKeys.BITBUCKET]: {
      free: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.FREE,
        edition: 'free',
        chargeElement: 'user'
      },
      standard: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'standard',
        chargeElement: 'user'
      },
      premium: {
        offeringId: '00000000-0000-0000-0000-000000000000',
        productKey: ProductKeys.BITBUCKET,
        pricingType: PricingType.PAID,
        edition: 'premium',
        chargeElement: 'user'
      }
    }
  }
} as const;

export type EnvironmentType = keyof typeof OFFERING_IDS;

export type CcpProduct = {
  readonly offeringId: string;
  readonly pricingPlanId: string;
  readonly pricingType: PricingType;
  readonly productKey: string;
  readonly edition: string;
  readonly chargeElement: string;
};

type MapProductKeyAndEditionToCcpProductOptions = {
  productKey: ProductKeys;
  edition: string;
};

export class OfferingCatalog {
  private readonly environmentType: EnvironmentType;

  public constructor(environmentType: EnvironmentType) {
    this.environmentType = environmentType;
  }

  public mapProductKeyAndEditionToCcpProduct = ({
    productKey,
    edition
  }: MapProductKeyAndEditionToCcpProductOptions): CcpProduct => {
    const products = OFFERING_IDS[this.environmentType];
    const editions =
      OFFERING_IDS[this.environmentType][productKey as keyof typeof products];

    return products[productKey as keyof typeof products][
      edition as keyof typeof editions
    ] as CcpProduct;
  };
}
